<script lang="ts">
      import { renderTick } from '$lib/utils/flip'
      import { onMount } from 'svelte'

      let { image, class: className = '', elementClass = '', respectAspect = true } = $props()
      let imageElement: HTMLImageElement

      let visible = $state(false)

      let init = $state(false)

      let _url = $derived.by(() => {
            if (!init) return ''
            if (!image) return
            if (image?.sizes?.extra?.url) return image.sizes.extra.url
            if (image?.sizes?.large?.url) return image.sizes.large.url
            if (image?.sizes?.webp?.url) return image.sizes.webp.url
            if (image?.url) return image.url
            return '/placeholder.webp'
      })

      let _blur = $derived.by(() => {
            if (!image) return '/placeholder.webp'
            if (image?.sizes?.blur?.url) return image.sizes.blur.url
            return '/placeholder.webp'
      })

      async function imageLoaded(imageElement: HTMLImageElement) {
            imageElement.parentElement?.style.removeProperty('aspect-ratio')
            visible = true
      }

      async function imageLoad(imageElement: HTMLImageElement) {
            await renderTick()
            setTimeout(() => {
                  init = true
            }, 500)

            setTimeout(() => {
                  if (!visible && imageElement) imageLoaded(imageElement)
            }, 5000)

            const ctrl = new AbortController()
            if (!imageElement) return
            if (imageElement.complete) {
                  imageLoaded(imageElement)
                  return
            }
            await new Promise((r) => {
                  imageElement.addEventListener(
                        'load',
                        () => {
                              ctrl.abort()
                              r(true)
                        },
                        { signal: ctrl.signal }
                  )
            })
            imageLoaded(imageElement)
      }

      $effect(() => {
            _url
            imageLoad(imageElement)
      })

      onMount(() => {
            //if (! _blur) visible = true
            imageLoad(imageElement)
      })
</script>

<div class="{className != '' ? className : 'block w-full object-cover'} relative select-none contain-paint " style="aspect-ratio: { respectAspect ? image?.width / image?.height/1 : "unset" }">
      {#if _blur}
            <div style="background-image: url('{_blur}'); aspect-ratio: { true ? image?.width / image?.height/1 : "unset" }" class="absolute top-0 left-0 w-full h-full blur-image z-[-1]"></div>
      {/if}
      {#if _url}
            <img
                  dragable="false"
                  bind:this={imageElement}
                  src={_url}
                  alt={image?.alt}
                  style=""
                  class="main-image {visible ? 'opacity-100' : 'opacity-0'} {elementClass == '' ? 'object-cover h-full w-full' : elementClass}"
                  width={image?.width}
                  height={image?.height} />
      {/if}
</div>

<style lang="postcss">
      .main-image {
            transition: opacity 0.7s ease-in-out;
      }

      .blur-image {
            background-position: center center;
            background-repeat: repeat;
            background-size: 100%;
            filter: blur(33px);
      }
</style>
